export const COOKIE_ALLOWED_KEY = 'cookie-allowed'
export const COOKIE_VALUE_YES = 'yes'
export const COOKIE_VALUE_NO = 'no'
